// src/pages/admin/Overview.jsx

import { Button, Badge, DataPageCard, DataTable, ReportStatusBadge } from "@common";
import { Link } from "react-router-dom";

export default function Overview({ clinics = [], isLoading = false, date }) {
  const sortedClinics = [...clinics].sort((a, b) => (a.clinic || "").localeCompare(b.clinic || ""));

  const columns = [
    {
      key: "clinic",
      header: "Clinic",
      nowrap: true,
    },
    {
      header: "Practitioner Production Reports",
      render: (r) => {
        const submitted = r.submittedReports?.submittedReports || 0;
        const total = r.submittedReports?.totalPractitioner || 0;

        return <ReportStatusBadge submitted={submitted} total={total} />;
      },
    },
    {
      header: "Collection Reports Submitted",
      render: (r) => (
        <Badge color={r.collectionSubmitted ? "success" : "danger"}>
          {r.collectionSubmitted ? "SUBMITTED" : "NOT SUBMITTED"}
        </Badge>
      ),
    },
    {
      header: "Forecast Report Submitted",
      render: (r) => (
        <Badge color={r.forecastSubmitted ? "success" : "danger"}>
          {r.forecastSubmitted ? "SUBMITTED" : "NOT SUBMITTED"}
        </Badge>
      ),
    },
    {
      header: "Daily Report File Upload",
      render: (r) => {
        // Soft-deleted files are already excluded server-side, so a clinic that
        // uploaded and then removed everything correctly reads as not submitted.
        const count = r.reportFilesUploaded ?? 0;
        return (
          <Badge color={count > 0 ? "success" : "danger"}>
            {count > 0 ? `${count} FILE(S) SUBMITTED` : "NOT SUBMITTED"}
          </Badge>
        );
      },
    },
    {
      key: "totalPatients",
      header: "Number of Patients Submitted",
      cellClassName: "font-mono",
      render: (r) => r.totalPatients ?? 0,
    },
    {
      header: "Management Actions",
      nowrap: true,
      render: (r) => (
        <Button
          as={Link}
          to={`/report/${encodeURIComponent(r.clinic)}`}
          size="sm"
          variant="outline"
          className="rounded-full px-4 py-1.5 border-2 border-palette-indigo-hover text-palette-indigo-heading hover:border-palette-indigo-ring"
        >
          Go to Clinic Dashboard
        </Button>
      ),
    },
  ];

  return (
    <div className="mt-2">
      <h2 className="text-lg font-bold mb-3">Reporting Status</h2>

      <DataPageCard
        isLoading={isLoading}
        error={null}
        isEmpty={false}
        loadingMessage="Loading overview..."
        showLoadingSpinner={true}
      >
        <DataTable
          columns={columns}
          data={sortedClinics}
          rowKey={(r) => r.clinic}
          isLoading={false}
        />
      </DataPageCard>
    </div>
  );
}
